import { API_BASE_URL } from "../api-config";
import secureLocalStorage from "react-secure-storage";
import { Cookies, useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

// Generate 256-bit BASE64 encoded hashes
const generateCsrfToken = function () {
  function generateRandomString(length) {
    let text = "";
    let possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  return generateRandomString(32);
};

export function call(api, method, request, unlogin_redirect) {
  let headers = new Headers({
    "Content-Type": "application/json",
  });

  // 클라이언트와 서버가 통신할때 쿠키 값을 공유하겠다는 설정
  let credentialsYn = false;
  credentialsYn = true;
  //랜덤 생성 토큰
  const csrfToken = generateCsrfToken();
  if (credentialsYn) {
    headers.append("c_csrfToken", csrfToken);
  }

  // 로컬 스토리지에서 ACCESS TOKEN 가져오기
  //const accessToken = localStorage.getItem("ACCESS_TOKEN");
  const accessToken = secureLocalStorage.getItem("ACCESS_TOKEN");
  // 세션 스토리지에서 ACCESS TOKEN 가져오기
  //const accessToken = sessionStorage.getItem("ACCESS_TOKEN");

  if (accessToken && accessToken !== null) {
    headers.append("Authorization", "Bearer " + accessToken);

    //headers.append("Access-Control-Allow-Origin", "*");

    //자바스크립트로는 쿠키를 가져오지 않는 것이 좋다.
    const cookies = new Cookies();
    const sessionId = process.env.REACT_APP_BACKEND_SERVER_JSESSIONID_NAME_KEY;

    // 클라이언트와 서버가 통신할때 쿠키 값을 공유하겠다는 설정
    if (credentialsYn) {
      cookies.remove("c.csrfToken");
      cookies.set("c.csrfToken", csrfToken, {
        path: "/",
        //httpOnly: true,
        //secure :true
        domain: process.env.REACT_APP_DOMAIN_NAME_KEY,
        //domain: "nc2030.com",
        //domain: "localhost",
        //domain: ".nc2030.com",
        //domain: "localhost:8080",
      });
    }

    if (cookies.get(sessionId)) {
      //headers.append(sessionId, cookies.get(sessionId));
    }
  }

  /*
  const jsessionid = secureLocalStorage.getItem("jsessionid");
  if (jsessionid && jsessionid !== null) {
    headers.append("jsessionid", jsessionid);
  }
  */

  let options = {
    headers: headers,
    url: API_BASE_URL + api,
    method: method,
  };
  ////
  ////
  ////
  ////  쿠키를 공유할것인가!!!!!??????????
  ////
  ////
  // 클라이언트와 서버가 통신할때 쿠키 값을 공유하겠다는 설정
  if (credentialsYn) {
    options.credentials = "include";
  }
  if (request) {
    // GET method
    options.body = JSON.stringify(request);
    //console.log(options.body);
  }
  return fetch(options.url, options) //비동기 호출
    .then(
      (response) => {
        //console.log(response.headers.get("Set-Cookie"));
        //console.log(response.headers.get("aToken"));
        console.log(response);

        if (response.status === 200) {
          return response.json();
        } else if (response.status === 403) {
          if (window.confirm("로그인 필요합니다. 로그인 하시겠습니까?")) {
            window.location.href = "/login"; // redirect
            return;
          } else {
            console.log("response :");
            console.log(response);
            console.log("unlogin_redirect :" + unlogin_redirect);
            if (unlogin_redirect) {
              //console.log(unlogin_redirect);
              window.location.href = unlogin_redirect;
            } else {
              window.location.href = "/home"; // redirect
            }
            //return;
            //const navigate = useNavigate();
            //navigate(-1);
          }
        } else {
          new Error(response);
          return response.json();
        }
      }
      /*
      ,rejected => {
        //promise가 reject 돼었을때 하고 싶은 작업. 
      }
      */
    )
    .catch((error) => {
      console.log("http error");
      console.log(error);
      //window.location.href = "/errorPage";

      setTimeout(() => {
        //console.log("대기시간 초과");
        window.location.href = "/errorPage?message=ERR_CONNECTION_REFUSED";
      }, 10000);
      /* */
    });
}

export function signin(userDTO) {
  return call("/auth/signin", "POST", userDTO).then((response) => {
    console.log(response);

    if (!response) {
      //반환값이 없을경우
      alert(
        "로그인에 실패하였습니다.가입정보를 확인하여 다시 로그인 해주세요."
      );
      window.location.href = "/login";
    } else if (response.token) {
      // 로컬 스토리지에 토큰 저장
      //localStorage.setItem("ACCESS_TOKEN", response.token);
      //localStorage.setItem("USER_TOKEN", response.username);

      //LocalStorage 를 사용할 것인가 아닌가???
      secureLocalStorage.setItem("ACCESS_TOKEN", response.token);
      secureLocalStorage.setItem("USER_TOKEN", response.username);

      // 세션 스토리지에 토큰 저장
      //sessionStorage.setItem("ACCESS_TOKEN", response.token);
      //sessionStorage.setItem("USER_TOKEN", response.username);

      // token이 존재하는 경우 Todo 화면으로 리디렉트
      window.location.href = "/";
    } else if (response.error) {
      alert("로그인에 실패하였습니다.비밀번호를 다시 확인해 주세요.");
    } else {
      alert("로그인에 실패하였습니다.가입정보를 다시 확인해 주세요.");
      window.location.href = "/login";
    }
  });
}

export function signout() {
  //localStorage.setItem("ACCESS_TOKEN", null);
  //localStorage.setItem("USER_TOKEN", null);
  secureLocalStorage.removeItem("ACCESS_TOKEN");
  secureLocalStorage.removeItem("USER_TOKEN");
  //sessionStorage.setItem("ACCESS_TOKEN", null);
  //sessionStorage.setItem("USER_TOKEN", null);
  //sessionStorage.removeItem("ACCESS_TOKEN");
  //sessionStorage.removeItem("USER_TOKEN");

  let userName = "";
  const userToken = secureLocalStorage.getItem("USER_TOKEN");
  if (userToken && userToken !== null) {
    userName = userToken;
  }
  const jsonbody = { username: userName };
  return call("/auth/signout", "POST", jsonbody).then((response) => {
    window.location.href = "/home";
  });
  //window.location.href = "/login";
}

export function signup(userDTO) {
  return call("/auth/signup", "POST", userDTO);
}

export function socialLogin(provider) {
  const frontendUrl = window.location.protocol + "//" + window.location.host;
  window.location.href =
    API_BASE_URL +
    "/auth/authorize/" +
    provider +
    "?redirect_url=" +
    frontendUrl;
}

export function userlist(object) {
  return call("/admin/userList", "POST", object);
}

export function pay(basketDTO) {
  const accessToken = secureLocalStorage.getItem("ACCESS_TOKEN");
  //basketDTO.append("token", accessToken);
  const id = basketDTO["id"];
  const object1 = { id: id, token: accessToken };

  //console.log(object1);

  //return call("/pay/pay", "POST", basketDTO);
  return call("/payready", "POST", object1).then((response) => {
    //console.log(response);

    //JSESSIONID
    const cookies = new Cookies();
    //cookies.set("JSESSIONID", response.message);
    if (response && response.message) {
      // cookies.remove("JSESSIONID");
      cookies.set(
        process.env.REACT_APP_BACKEND_SERVER_JSESSIONID_NAME_KEY,
        response.message,
        {
          path: "/",
          //httpOnly: true,
          //secure :true
          domain: process.env.REACT_APP_DOMAIN_NAME_KEY,
          //domain: "nc2030.com",
          //domain: "localhost",
          //domain: ".nc2030.com",
          //domain: "localhost:8080",
        }
      );
      //secureLocalStorage.setItem("JSESSIONID", response.message);
    }

    console.log(response);
    if (response) {
      //반환값이 없을경우
      //console.log(response.data);
      //window.location.href = response.data;

      window.open(
        response.data,
        "결제페이지",
        "width=700px,height=800px,scrollbars=yes"
      );
      //window.location.href = "/basketList";
      window.location.href = "/"; // 또는 결제 완료페이지로
    } else if (!response) {
      // 반환값이 없을경우
      //if (window.confirm("로그인 필요합니다. 로그인 하시겠습니까?")) {
      // alert("로그인에 실패하였습니다.가입정보를 확인하여 다시 로그인 해주세요.");
      //window.location.href = "/login";
      //} else {
      //const navigate = useNavigate();
      //navigate(-1);
      // onCancel();
      //}
    } else {
      alert("로그인 실패.");
      window.location.href = "/login";
    }
  });
}

export function pays(object) {
  const accessToken = secureLocalStorage.getItem("ACCESS_TOKEN");

  //console.log("dddddddd");
  //console.log(object["basket"]);
  const id = object["basket"];

  if (id && accessToken) {
    const api = "/pay?id=" + id + "&token=" + accessToken;
    const url = API_BASE_URL + api;
    window.location.href = url;

    /*
    const object1 = { id: id, token: accessToken };
    return call("/pay?id=" + id, "POSt", object1).then((response) => {
      console.log(response);
      if (response) {
        //반환값이 없을경우
        //console.log(response.data);
        //window.location.href = response.data;
      }
    });
    */
  } else {
    alert("로그인 필요합니다.");
    window.location.href = "/login";
  }
}

///
export function payCompleted(object) {
  return call("/pay/completed", "POST", object).then((response) => {
    console.log(response);
    if (response.data) {
      window.location.href = response.data;
    }

    if (!response) {
      //alert("결제되었습니다.");
      window.location.href = "/home";
    }

    //alert(response);
    //window.location.href = response;
    //window.location.href = "/home";
  });
}

export function payCancel(object) {
  window.location.href = "/basketList";
  //return call("/pay/completed", "GET", object);
}
export function payFail(object) {
  window.location.href = "/home";
  //return call("/pay/completed", "GET", object);
}

////
export function addBasket(basketDTO, unlogin_redirect) {
  //const accessToken = secureLocalStorage.getItem("ACCESS_TOKEN");
  //basketDTO.append("token", accessToken);
  //const id = basketDTO["id"];
  //const object1 = { id: id, token: accessToken };
  //alert("clikck" + basketDTO);
  //return call("/pay/pay", "POST", basketDTO);
  //return call("/basket/create", "POST", basketDTO);

  return call("/basket/create", "POST", basketDTO, unlogin_redirect).then(
    (response) => {
      //console.log(response);

      //console.log(response);

      if (!response) {
        return;
      }

      if (response.status && response.status === 400) {
        //내부 오류
        alert("오류가 있습니다 다시 시도해 주세요");
        return;
      }

      if (response.error) {
        if (response.message === "A") {
          //초과
          alert(response.error);
          return;
          // window.location.href = "/item";
        }
        if (response.error === "B") {
          //null
          alert(response.error);
          window.location.href = "/item";
        }
        //if (window.confirm("로그인이 필요합니다. 로그인 페이지로 갈까요?")) {
        // window.location.href = "/login";
        //}
      }

      if (response.data) {
        if (window.confirm("장바구니에 담겼어요. 장바구니 페이지로 갈까요?")) {
          window.location.href = "/basketList";
        }

        //console.log(response.data);
        //window.location.href = response.data;
      } else if (!response) {
        // 반환값이 없을경우
        alert("장바구니 안 담겼어요.");
        //if (window.confirm("로그인 필요합니다. 로그인 하시겠습니까?")) {
        // alert("로그인에 실패하였습니다.가입정보를 확인하여 다시 로그인 해주세요.");
        //window.location.href = "/login";
        //} else {
        //const navigate = useNavigate();
        //navigate(-1);
        // onCancel();
        //}
      } else {
        alert(" 실패.");
        console.log(response.error);
        //window.location.href = "/login";
      }
    }
  );
}
